<template>
  <div class="content">

    <div class="fixed">
      <b-navbar type="light" variant="light">
        <b-navbar-nav>
          <b-button pill variant="secondary" :to="urlBack()" v-if="hasBack()"><b-icon icon="caret-left" aria-hidden="true"></b-icon>Retour</b-button>
          <b-nav-text v-if="data.account" data.account>{{data.account.name}} - {{data.company.name}}</b-nav-text>
          <!-- Navbar dropdowns -->
          <b-nav-item-dropdown text="Envoyer un e-mail" left v-if="data.operation" >
            <b-dropdown-item :href="`mailto:${data.account.name}<${data.account.email}>?subject=Operation ${data.operation.code} - ${data.operation.operationname}`" target="_blank">Compte : {{data.account.name}} - {{data.account.email}}</b-dropdown-item>
            <b-dropdown-item :href="`mailto:${data.company['operationOfficer.name']}<${data.company['operationOfficer.email']}>?subject=Operation ${data.operation.code} - ${data.operation.operationname}`" target="_blank" v-if="data.company['operationOfficer.email']">Resp. opérations : {{data.company['operationOfficer.name']}} - {{data.company['operationOfficer.email']}}</b-dropdown-item>
            <b-dropdown-item :href="`mailto:${data.company['companyOwner.name']}<${data.company['companyOwner.email']}>?subject=Operation ${data.operation.code} - ${data.operation.operationname}`" target="_blank" v-if="data.company['companyOwner.email']">Resp. entreprise : {{data.company['companyOwner.name']}} - {{data.company['companyOwner.email']}}</b-dropdown-item>
            <b-dropdown-item v-if="isAdmin()" :to="urlSendEmail()" >Email EU quand EE valide</b-dropdown-item>
            <b-dropdown-item v-if="isAdmin()" :to="urlSendEmailEE()" >Email EE</b-dropdown-item>
            <b-dropdown-item v-if="isAdmin()" :to="urlSendEmailEEContact()" >Email contact EE</b-dropdown-item>
            <b-dropdown-item v-if="isAdmin()" :to="urlSendEmailNewYearEE()" >Email nouvelle année EE</b-dropdown-item>

          </b-nav-item-dropdown>

          <b-nav-item-dropdown text="Modifier" left>
            <b-dropdown-item v-if="data.account && isAdminManagerOrPartner()" :to="urlWithRedirect('/ppe_ee/home/'+data.account.id)">Accéder au compte : {{data.account.email}} - {{data.company.name}}</b-dropdown-item>
            <b-dropdown-item v-if="data.account && isAdminManagerOrPartner()" :to="urlWithRedirect('/ppe_ee/operation_ee/'+data.account.id+'/'+data.id)">Changer l'état de {{data.company.name}}</b-dropdown-item>
            <b-dropdown-item v-if="data.account && isAdminManagerOrPartner()" @click.prevent="resetPasswordAndSendEmail" :disabled="resetPasswordInProgress">Reinitialiser le mot de passe</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>
    </div>


    <div class="container-fluid">
      
      <div class="row" v-if="data.operation">
        <div class="col-lg-12 col-12">
          <stats-card :style="getCardStyle(data._status)">
            <div slot="content">
              <img v-if="data.operation.image && data.operation.image.length" style="max-height:200px;max-width:200px" class="float-right" :src="`${this.$http.baseURL}/form/image?uid=${data.operation.image[0].name}`" />
              <h4 class="card-title"><status-icon :status="data._status" css-class="icon-small"/> {{data.operation.code}} - {{data.operation.operationname}} 
                <!-- <a v-if="isAdmin()" :href="'/ppe_eu/operation_home/'+data.operation.id">Retour opération (admin)</a> -->
                <router-link v-if="isAdmin()" :to="urlWithRedirect('/ppe_eu/operation_home/'+data.operation.id)">Retour opération (admin)</router-link>
              </h4>
              <h5 v-if="data.companyOp">{{data.companyOp.name}} - {{data.companyOp.city}} - {{data.companyOp.activity}} </h5>
              <div class="row">
                  <div class="col-lg-2 col-4"><span class="font-weight-bold">Opération</span></div>
                  <div class="col-lg-5 col-8">{{data.operation.code}}</div>
                  <div class="col-lg-2 col-4"><span class="font-weight-bold">Type</span></div> <!-- https://bootstrap-vue.org/docs/reference/utility-classes -->
                  <div class="col-lg-3 col-8">{{getOperationLabel(data.operation.type)}}</div>
              </div>
              <div class="row">
                  <div class="col-lg-2 col-4"><span class="font-weight-bold">Description</span></div>
                  <div class="col-lg-10 col-8"><span style="white-space: pre-line">{{data.operation.description}}</span></div>
              </div>
              <div class="row">
                <div class="col-lg-2 col-4"><span class="font-weight-bold">Adresse</span></div> 
                <div class="col-lg-10 col-8"><div>{{data.operation.sitename}}</div>
                <div>{{data.operation.address}} {{data.operation.zip}} {{data.operation.city}}</div></div>
              </div>
                  <div class="row">
                    <div class="col-lg-2 col-4"><span class="font-weight-bold">Début prévu</span></div>
                    <div class="col-lg-3 col-8">{{toDate(data.operation.startDate)}}</div>
                    <div class="col-lg-2 col-4"><span class="font-weight-bold">Durée</span></div> 
                    <div class="col-lg-3 col-8">{{data.operation.duration}}</div>
                  </div>
            </div>
            <div slot="footer">
                  <div>
                    <i v-if="this.data.d3" class="fa fa-calendar-o"></i> {{toDate(data._modified)}}
                    <span> | </span>
                    <router-link class="card-link" v-if="isAdminManagerOrPartner()" :to="urlWithRedirect('/ppe_ee/operation_ee/'+data.account.id+'/'+data.id)">Modifier état (admin)</router-link>
                  </div>
            </div>
          </stats-card>

        </div>

        <div class="col-lg-12 col-12 warning" v-if="this.data.hadD1D3Copied && (this.data.d1._status=='draft' || this.data.d3._status=='draft' || this.data.d4._status=='draft')">
          <i class="fa fa-warning"></i> Les documents D1 et D3 suivants ont été recopiés depuis votre précédente opération. Merci de les vérifier.
          <br />
          Vous devez également compléter le D4.
        </div>

        <!-- D0. Vos sous traitants -->
        <div class="col-lg-12 col-12">
          <stats-card :style="getCardStyle(data.d0._status)">
            <div slot="content">
              <h4 class="card-title"><status-icon v-if="this.data.d0" :status="this.data.d0._status" />
              <status-icon v-if="!this.data.d0" status="draft" /> D0. Vos sous traitants</h4>
              <p class="card-category">Liste de vos sous traitants intervenant sur cette opération</p>
              <p class="card-category" v-if="!data.d0.no_contractors">Vous avez déclaré {{ data.d0.contractors.length }} sous-traitant{{ data.d0.contractors.length>1?'s':'' }}</p>
              <p class="card-category primary" v-else>Vous n'avez pas de sous-traitants sur cette opération</p>
              <b-table responsive striped hover :items="data.d0.contractors" :fields="contrator_fields" v-if="data.d0.contractors.length>0">

                <template #cell(action)="row">
                  <button class="btn btn-secondary btn-sm float-right" v-on:click="sendInviteWithConfirm(row.item.email, row.item.name)" >Envoyer un email d'invitation</button>
                  <button title="Réinitialise le mot de passe du compte (le crée et l'inscrit à l'opération si nécessaire)" class="btn btn-warning btn-sm float-right" v-on:click="resetContractorPasswordWithConfirm(row.item)" >🔑 Réinitialiser mdp</button>
                </template>

                <template #cell(lastSent)="row">
                  {{toDate(row.item.lastSent)}}
                </template>

                <template #cell(user)="row">
                  <div v-if="row.item.user" >
                  <router-link :to="urlWithRedirect(`/ppe_ee/home/${row.item.user.id}`)" >
                  {{row.item.user.name}}
                  </router-link>  
                  <div>{{row.item.user.company.name}} - <span style="white-space:nowrap">{{toDate(row.item.user._modified)}}</span></div>
                  </div>
                </template>

              </b-table>
            </div>
            <div slot="footer">
              <i v-if="this.data.d1" class="fa fa-calendar-o"></i> {{this.data.d0?toDate(this.data.d0._modified):''}}
              <span> | </span>
              <router-link :to="urlWithRedirect('/ppe_ee/d0/'+this.data.d0.id+'?operationid='+data.operation.id+'&companyid='+data.company.id)">Modifier</router-link>

            </div>
          
          </stats-card>

        </div>

        <!-- D1. Protocole de sécurité -->
        <div class="col-lg-5 col-12"> 
          <stats-card :style="getCardStyle(this.data.d1._status)">
            <div slot="content">
              <h4 class="card-title"><status-icon v-if="this.data.d1" :status="this.data.d1._status" />
              <status-icon v-if="!this.data.d1" status="draft" /> D1. Protocole de sécurité</h4>
              <p class="card-category">Opérations de chargement et de déchargement</p>
              <p class="card-category">(art R4515-1 à R4515-11 du C du T précisé par arrêté du 26 04 96)</p>
            </div>
            <div slot="footer">
              <i v-if="this.data.d1" class="fa fa-calendar-o"></i> {{this.data.d1?toDate(this.data.d1._modified):''}}
              <span> | </span>
              <router-link :to="urlWithRedirect('/ppe_ee/d1/'+this.data.d1.id+'?operationid='+data.operation.id+'&companyid='+data.company.id)">Modifier</router-link>
              <span> | </span>
              <a href="#"  @click="downloadD1PDF" class="card-link" v-if="['doing','valid'].includes(data.d1._status)">
                      <!-- https://bootstrap-vue.org/docs/icons#icons-1 -->
                      <b-icon icon="file-earmark-arrow-down" title="Télécharger au format PDF"></b-icon>Télécharger
                      <b-icon icon="arrow-clockwise" animation="spin" font-scale="2" v-if="pdfD1Loading"></b-icon>
                      </a> 

            </div>
          </stats-card>
        </div>

        <!-- D3. LAP Livret d'Accueil -->
        <div class="col-lg-5 col-12"> 
          <stats-card :style="getCardStyle(this.data.d3._status)">
            <div slot="content">
              <h4 class="card-title"><status-icon v-if="this.data.d3" :status="this.data.d3._status" />
              <status-icon v-if="!this.data.d3" status="draft" /> D3. LAP Livret d'Accueil Prévention</h4>
              <p class="card-category">Analyse des principaux dangers</p>
              <p class="card-category">Cochez tous vos risques dans la colonne E.E.</p>
            </div>
            <div slot="footer">
              <i v-if="this.data.d3" class="fa fa-calendar-o"></i> {{this.data.d3?toDate(this.data.d3._modified):''}}
              <span> | </span>
              <router-link :to="urlWithRedirect('/ppe_ee/d3/'+this.data.d3.id+'?operationid='+data.operation.id+'&companyid='+data.company.id)">Modifier</router-link>
            </div>
          </stats-card>
        </div>

        <!-- D4. Bordereau d’Engagement SST de l’OPERATION -->
        <div class="col-lg-5 col-12"> 
          <stats-card :style="getCardStyle(this.data.d4._status)">
            <div slot="content">
              <h4 class="card-title"><status-icon v-if="this.data.d4" :status="this.data.d4._status" />
              <status-icon v-if="!this.data.d4" status="draft" /> D4. Bordereau d’Engagement SST de l’OPERATION</h4>
              <p class="card-category">Description / inspection / signature</p>

              
            </div>
            <div slot="footer">
              <i v-if="this.data.d4" class="fa fa-calendar-o"></i> {{this.data.d4?toDate(this.data.d4._modified):''}}
              <span> | </span>
              <router-link :to="urlWithRedirect('/ppe_ee/d4/'+this.data.d4.id+'?operationid='+data.operation.id+'&companyid='+data.company.id)">Modifier</router-link>
              <span> | </span>
              <a href="#"  @click="downloadD4PDF" class="card-link" v-if="['doing','valid'].includes(data.d4._status)">
                      <!-- https://bootstrap-vue.org/docs/icons#icons-1 -->
                      <b-icon icon="file-earmark-arrow-down" title="Télécharger au format PDF"></b-icon>Télécharger
                      <b-icon icon="arrow-clockwise" animation="spin" font-scale="2" v-if="pdfD4Loading"></b-icon>
                      </a> 
             </div>
          </stats-card>
        </div>
        
        <div class="col-lg-5 col-12"> 
          <div :style="getCardStyle('valid') + '; padding: 10pt;'" class="card">
            <h4 class="card-title">Plan de Prévention Evolutif de l'EU sur l'opération</h4>
            <div slot="content">
              <a href="#" v-if="docsCompleted()" @click="downloadPDF" class="card-link">
                  <!-- https://bootstrap-vue.org/docs/icons#icons-1 -->
                  <b-icon icon="file-earmark-arrow-down" title="Visualiser au format PDF"></b-icon>
                  Télécharger le PPE
                  <b-icon icon="arrow-clockwise" animation="spin" font-scale="2" v-if="pdfLoading"></b-icon>
              </a> 
              <div v-if="!docsCompleted()" >
                Vous pourrez télécharger le PPE, après validation D3 & D4
              </div>
            </div>
          </div>
        </div>
      </div>
<div class="alert alert-warning mt-4 bg-orange-500" role="alert">
  Pensez à soumettre votre dossier quand vous n'avez plus de bordures rouges sur vos cartes D0, D1 D3 D4.

</div>
      <div class="row mt-4" v-if="data.operation">
        <div class="col-12">
          <div class="d-flex flex-column flex-md-row justify-content-end align-items-stretch">
            <b-button
              variant="primary"
              class="btn primary mb-3 mb-md-0"
              :disabled="!docsCompleted() || submitInProgress"
              @click.prevent="submitForValidation"
            >
              Soumettre mon dossier pour validation
            </b-button>
            <b-button
              variant="outline-secondary"
              class="mb-3 mb-md-0 mr-md-3"
              @click.prevent="showSaveLaterMessage"
            >
              Tout enregistrer et compléter plus tard
            </b-button>
          </div>
        </div>
      </div>
    
      
    </div>
  </div>
</template>
<script>
  
  import ChartCard from '../../components/Cards/ChartCard.vue'
  import StatsCard from '../../components/Cards/StatsCard.vue'
  import StatusIcon from '../../components/StatusIcon.vue'

  import Business, { baseApiURL } from 'ppe-business'
  import common from '../common/pages.js'

  export default {
    components: {
      ChartCard,
      StatsCard,
      StatusIcon
    },


    mounted() {
      this.$http.get('/ee/operation_subscription_home?id='+this.$route.params.id) // this.$router.app._route.query.id)
        .then(response => {
          console.log("/ee/operation_subscription_home:DATA", response.data)
          this.data = response.data
          } )
        .catch(err => {
          // Clone the error to read the status property (otherwise it can only be read once !!!!)
          let error = JSON.parse( JSON.stringify(err) )
          console.error("ERROR", JSON.stringify(error))
					swal("Erreur", JSON.stringify(err.response ? err.response.data : error.message), "error");
          //if(error.status === 401)
          //   this.$router.replace("/login?redirect="+error.config.url)
        })
    },

    data () {
      return {
        pdfLoading : false,
        pdfD4Loading:false,
        pdfD1Loading:false,
        contrator_fields: [
          {key:'name',   label: 'Entreprise'},
          {key:'email',  label: 'Email'},
          {key:'tasks',  label: 'Tâches'},
          {key:'user',   label: 'Inscrit'}, 
          {key:'action', label: 'Action'}, 
          {key:'lastSent', label: 'Dernier envoi', tdClass: 'text-nowrap'}, 
        ],
        data : {},
        submitInProgress: false,
        resetPasswordInProgress: false,
        
       }
    },

    methods:{
      ...common.methods,

      toDate(apiDate) { return Business.toDate(apiDate) },
      getOperationLabel(operationType) { return Business.getOperationLabel(operationType) },
      urlSendEmail() {
        return this.urlWithRedirect(`/admin/sendemail?template_id=mail_valid_ee&eeid=${this.data.company.id}&euid=${this.data.operation.company.id}&operationid=${this.data.operation.id}&accountid=${this.data.operation.company.owner}`)
      },
      urlSendEmailEEContact() {
        return this.urlWithRedirect(`/admin/sendemail?template_id=mail_contact_ee&eeid=${this.data.company.id}&euid=${this.data.operation.company.id}&operationid=${this.data.operation.id}&accountid=${this.data.company.owner}`)
      },
      urlSendEmailEE() {
        return this.urlWithRedirect(`/admin/sendemail?template_id=mail_ee&eeid=${this.data.company.id}&euid=${this.data.operation.company.id}&operationid=${this.data.operation.id}&accountid=${this.data.company.owner}`)
      },
      urlSendEmailNewYearEE() {
        return this.urlWithRedirect(`/admin/sendemail?template_id=mail_new_year_ee&eeid=${this.data.company.id}&euid=${this.data.operation.company.id}&operationid=${this.data.operation.id}&accountid=${this.data.company.owner}`)
      },
      async resetPasswordAndSendEmail() {
        if(!this.data.account || this.resetPasswordInProgress) return
        const confirmReset = await swal({
          title: 'Réinitialiser le mot de passe ?',
          text: `Un mot de passe temporaire sera généré pour ${this.data.account.email}.`,
          icon: 'warning',
          buttons: {
            cancel: 'Annuler',
            confirm: {text: 'Oui, réinitialiser', className: 'btn btn-warning'},
          },
        })
        if(!confirmReset) return
        this.resetPasswordInProgress = true
        try {
          const response = await this.$http.post('/admin/reset_account_password', { accountid: this.data.account.id })
          const tempPassword = response && response.data ? response.data.temporaryPassword : null
          if(!tempPassword) throw new Error('Aucun mot de passe temporaire reçu du serveur.')
          const email = this.data.account.email
          const subject = encodeURIComponent('Réinitialisation de votre accès PPE')
          const loginUrl = `${window.location.origin}/login/${encodeURIComponent(email)}`
          const bodyLines = [
            `Bonjour ${this.data.account.name || ''},`,
            '',
            `Votre mot de passe temporaire PPE est : ${tempPassword}`,
            '',
            '(ne copiez pas l\'espace final)',
            '',
            `Merci de vous connecter sur ${loginUrl} pour le personnaliser lors de votre prochaine connexion.`,
            '',
            'Ce mot de passe est provisoire et devra être remplacé immédiatement.',
          ]
          const body = encodeURIComponent(bodyLines.join('\n'))
          const link = document.createElement('a')
          link.href = `mailto:${email}?subject=${subject}&body=${body}`
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          swal('Mot de passe réinitialisé', 'Un email pré-rempli s\'ouvre dans votre messagerie.', 'success')
        } catch(err) {
          const message = err.response && err.response.data ? (err.response.data.error || err.response.data.message) : err.message
          const displayMessage = typeof message === 'string' ? message : JSON.stringify(message)
          swal('Erreur', displayMessage, 'error')
        } finally {
          this.resetPasswordInProgress = false
        }
      },
      downloadD4PDF() { 
        this.pdfD4Loading = true
        this.$http.get('/form/d4_pdf?id='+this.data.d4.id, {responseType: 'arraybuffer', timeout:30000}) 
        .then(response=> {
          //console.log(response)
          //this.$http.timeout = lastTimeout
          let blob = new Blob([response.data], { type: 'application/pdf' })
          // Download file and give it a name
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'PPE-BORDEREAU-ENGAGEMENT-'+this.data.operation.code+'.pdf'
          this.pdfD4Loading = false
          link.click()

        })
        .catch( err => {
          //this.$http.timeout = lastTimeout
          this.pdfD4Loading = false
          //console.error("ERROR 1")
          let responseError = err.response
          let blobErr = new Blob([responseError.data], { type: 'application/json' })
          //console.log(responseError)
          let fileReader = new FileReader()
          
          fileReader.onload = (e) => {
            console.error("ERROR 1")
            console.error(JSON.parse(e.target.result))
  					swal("Erreur", JSON.stringify(JSON.parse(e.target.result).error), "error");
          }
          
          fileReader.readAsText(blobErr)
          
          console.log("ERROR BLOB", blobErr)
          //let error = JSON.parse(JSON.stringify(err))
          //console.error("ERROR 2", JSON.stringify(error))
        })
      },

      downloadD1PDF() { 
        this.pdfD1Loading = true
        this.$http.get('/form/d1_pdf?id='+this.data.d1.id, {responseType: 'arraybuffer', timeout:30000}) 
        .then(response=> {
          let blob = new Blob([response.data], { type: 'application/pdf' })
          // Download file and give it a name
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'PPE-PROTOCOLE-SECURITE-'+this.data.operation.code+'.pdf'
          this.pdfD1Loading = false
          link.click()

        })
        .catch( err => {
          this.pdfD1Loading = false
          let responseError = err.response
          let blobErr = new Blob([responseError.data], { type: 'application/json' })
          let fileReader = new FileReader()
          
          fileReader.onload = (e) => {
            console.error("ERROR 1")
            console.error(JSON.parse(e.target.result))
  					swal("Erreur", JSON.stringify(JSON.parse(e.target.result).error), "error");
          }
          
          fileReader.readAsText(blobErr)
          
          console.log("ERROR BLOB", blobErr)
        })
      },

      downloadPDF() {
        this.pdfLoading = true;
        //console.log("this.$http", this.$http.config())
        //let lastTimeout = this.$http.timeout;
        //this.$http.timeout = 30000
        this.$http.get('/form/operation_pdf?operationId='+this.data.operation.id, {responseType: 'arraybuffer', timeout:30000}) 
        .then(response=> {
          //console.log(response)
          //this.$http.timeout = lastTimeout
          let blob = new Blob([response.data], { type: 'application/pdf' })

          /*let url = window.URL.createObjectURL(blob)
          this.pdfLoading = false
          let win = window.open(url)*/
 
          /*const newWindow = window.open()
          newWindow.document.title = 'My Tab Name'
          newWindow.document.write(`<iframe src="${URL.createObjectURL(blob)}" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`)
          */

          /*let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'PPE-'+this.operation.code+'.pdf'
          link.click()*/

          // Download file and give it a name
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'PPE-'+this.data.operation.code+'.pdf'
          this.pdfLoading = false
          link.click()
        })
        .catch( err => {
          //this.$http.timeout = lastTimeout
          this.pdfLoading = false
          //console.error("ERROR 1")
          let responseError = err.response
          let blobErr = new Blob([responseError.data], { type: 'application/json' })
          //console.log(responseError)
          let fileReader = new FileReader()
          
          fileReader.onload = (e) => {
            console.error("ERROR 1")
            console.error(JSON.parse(e.target.result))
  					swal("Erreur", JSON.stringify(JSON.parse(e.target.result).error), "error");
          }
          
          fileReader.readAsText(blobErr)
          
          console.log("ERROR BLOB", blobErr)
          //let error = JSON.parse(JSON.stringify(err))
          //console.error("ERROR 2", JSON.stringify(error))
        })
      },
      isAdmin() {
        return this.$usermanager.isAdmin() //|| this.$usermanager.isImpersonating()
      },
      docsCompleted() {
        let states = ['valid', 'doing']
        return this.data.d3 && this.data.d4 &&
          states.indexOf(this.data.d3._status) >=0 && states.indexOf(this.data.d4._status)>=0
      },
      showSaveLaterMessage() {
        swal({
          title: "Vous pouvez revenir plus tard",
          text: "Vos informations sont enregistrées au fur et à mesure. Revenez quand vous le souhaitez pour compléter votre dossier.",
          icon: "info",
          buttons: {
            confirm: {text:"Compris", className:"btn btn-info"},
          },
        })
      },
      async submitForValidation() {
        if(!this.docsCompleted() || this.submitInProgress) return
        const confirmed = await swal({
          title: 'Soumettre votre dossier ?',
          text: "Votre dossier sera transmis à l'E.U. pour validation.",
          icon: 'info',
          buttons: {
            cancel: "Annuler",
            confirm: {text:"Oui, soumettre", className:"btn btn-primary"},
          },
        })
        if(!confirmed) return
        this.submitInProgress = true
        try {
          const response = await this.$http.post(`/ee/operation_ee?id=${this.data.id}`, {_status:'received'})
          if(response && response.data && response.data.entity) {
            this.data._status = response.data.entity._status
            this.data._modified = response.data.entity._modified
          } else {
            this.data._status = 'received'
          }
          await this.$http.post(`/ee/operation_ee_submit?id=${this.data.id}`, response)
          swal("Dossier envoyé", "Votre dossier a été soumis pour validation.", "success")
        } catch(err) {
          swal("Erreur", JSON.stringify( err.response ? err.response.data : err.message), "error");
        } finally {
          this.submitInProgress = false
        }
      },
      async sendInviteWithConfirm(email, companyName) {
        var answer = await swal({
              title: 'Confirmez ?',
              text: `Vous allez envoyer une invitation à ${email} à rejoindre l'opération ${this.data.operation.code}\n`,
              icon: 'info',

              buttons: {
                    cancel: {text:"Non, annuler", value: null, visible: true, className: "btn btn-secondary"},
                    mailto: {text:"Envoyer avec ma messagerie", value: "mailto", visible: true, className: "btn btn-outline-secondary"},
                    confirm: {text:"Oui, envoyer", value: true, visible: true, className:"btn btn-info"},
              },
            })
            if(answer === 'mailto') {
              await this.sendInviteWithMailClient(email, companyName)
              return
            }
            if(answer) {
              //try {
                let response = await this.$http.post("/ee/operation_invite", 
                  { code:this.data.operation.code, 
                    operationname:this.data.operation.operationname,
                    sitename:this.data.operation.sitename,
                    operationid:this.data.operation.id, 
                    to:email, 
                    company:companyName, 
                    accountName:this.data.account.name, 
                    accountCompany:this.data.company.name
                  });

                swal({
                  title: "Email envoyé !",
                  text: `A: ${email} de la société ${companyName}`,
                  icon: "success"
                });

                this.invites = response.data.invites

              /*} catch(err) {
                swal("Erreur", JSON.stringify( err.response ? err.response.data : err.message), "error");
              } */
            }
      },
      async sendInviteWithMailClient(email, companyName) {
        try {
          const response = await this.$http.post("/ee/operation_invite",
            { code:this.data.operation.code,
              operationname:this.data.operation.operationname,
              sitename:this.data.operation.sitename,
              operationid:this.data.operation.id,
              to:email,
              company:companyName,
              accountName:this.data.account.name,
              accountCompany:this.data.company.name,
              preview:true,
              excludeSignature:true,
            });

          const subject = encodeURIComponent(response.data.subject || '')
          const plainBody = response.data.text || this.plainTextFromHtml(response.data.html || '')
          const body = encodeURIComponent(plainBody)
          const queryParts = []
          if(subject) queryParts.push(`subject=${subject}`)
          if(body) queryParts.push(`body=${body}`)
          const query = queryParts.join('&')
          const link = document.createElement('a')
          link.href = query ? `mailto:${email}?${query}` : `mailto:${email}`
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } catch(err) {
          swal("Erreur", JSON.stringify( err.response ? err.response.data : err.message), "error");
        }
      },
      async resetContractorPasswordWithConfirm(contractor) {
        const email = contractor.email
        if(!email) {
          swal("Erreur", "Impossible d'identifier l'email du sous-traitant.", "error");
          return
        }
        const recipientLabel = contractor.name ? `${contractor.name} (${email})` : email
        const confirmed = await swal({
          title: 'Réinitialiser le mot de passe ?',
          text: `Un compte sera créé et inscrit à l'opération si nécessaire pour ${recipientLabel}, un mot de passe temporaire lui sera affecté et un email pré-rempli s'ouvrira dans votre messagerie.`,
          icon: 'warning',
          buttons: {
            cancel: 'Annuler',
            confirm: {text: 'Oui, réinitialiser', className: 'btn btn-warning'},
          },
        })
        if(!confirmed) return

        try {
          const response = await this.$http.post('/ee/operation_invite_reset_password', {
            operationid: this.data.operation.id,
            to: email,
            company: contractor.name,
          })
          const { temporaryPassword, account, created, subscribed } = response.data
          if(!temporaryPassword || !account) throw new Error('Réponse invalide du serveur.')

          const subject = encodeURIComponent('Réinitialisation de votre accès PPE')
          const loginUrl = `${window.location.origin}/login/${encodeURIComponent(account.email)}`
          const bodyLines = [
            `Bonjour ${account.name || contractor.name || ''},`,
            '',
            `Votre mot de passe temporaire PPE est : ${temporaryPassword}`,
            '',
            '(ne copiez pas l\'espace final)',
            '',
            `Merci de vous connecter sur ${loginUrl} pour le personnaliser lors de votre prochaine connexion.`,
            '',
            'Ce mot de passe est provisoire et devra être remplacé immédiatement.',
          ]
          const body = encodeURIComponent(bodyLines.join('\n'))
          const link = document.createElement('a')
          link.href = `mailto:${account.email}?subject=${subject}&body=${body}`
          link.style.display = 'none'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          if(created || subscribed) {
            const refreshed = await this.$http.get('/ee/operation_subscription_home?id='+this.$route.params.id)
            this.data = refreshed.data
          }

          swal('Mot de passe réinitialisé', 'Un email pré-rempli s\'ouvre dans votre messagerie.', 'success')
        } catch(err) {
          const message = err.response && err.response.data ? (err.response.data.error || err.response.data.message) : err.message
          const displayMessage = typeof message === 'string' ? message : JSON.stringify(message)
          swal('Erreur', displayMessage, 'error')
        }
      },
      plainTextFromHtml(html) {
        if (!html) return ''
        return html
          .replace(/<a\s+[^>]*href=["']([^"']+)["'][^>]*>([\s\S]*?)<\/a>/gi, '$2 ($1)')
          .replace(/<br\s*\/?>/gi, '\n')
          .replace(/<\/p>/gi, '\n\n')
          .replace(/<[^>]*>/g, '')
          .replace(/&nbsp;/gi, ' ')
          .replace(/&amp;/gi, '&')
          .replace(/&lt;/gi, '<')
          .replace(/&gt;/gi, '>')
          .trim()
      },
    },

  }
</script>
<style>

</style>
